import { useContext, useEffect, useState } from 'react';

import Infobar from '@/components/Infobar';
import SearchBanner from '@/components/SearchBanner';
import { appDataContext } from '@/context';
// import { useScreenDetector } from "@/utils/useScreenDetector";
import styled from 'styled-components';

// Ensure component is client-only safe regarding screen detection
const StaticPageLayout = (props) => {
  // Removed unused isTablet
  // const { isTablet } = useScreenDetector();
  const JSON = useContext(appDataContext);
  const text = JSON.lang;
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    // Wait for hydration to complete before rendering dynamic components
    const timer = setTimeout(() => {
      setIsHydrated(true);
    }, 200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <>
      {/*
         Removed Suspense for Infobar as it's now static.
         Infobar is top-level and critical for CLS, so static is better.
      */}
      <Infobar />

      <DesktopOnly>
        {isHydrated ? (
          <SearchBanner lang={text} $isWhite />
        ) : (
          <div style={{ minHeight: '80px' }}></div>
        )}
      </DesktopOnly>
      <Container>
        <Wrapper>{props.children}</Wrapper>
      </Container>
    </>
  );
};

export default StaticPageLayout;

const Container = styled.div`
  background-color: ${(props) => props.theme.colors.grey};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media screen and (min-width: 768px) {
    padding: 32px 64px;
  }
  width: 100%;
`;

const Wrapper = styled.div.attrs({
  className: `common wrapper static`,
})`
  display: block;
  background: white;
  transition: all 0.1s ease-in-out;
  padding: 12px;
  border-radius: 5px;
  flex: 0 1 auto;

  header {
    background-color: #fefefe;
    border-radius: 4px 4px 0 0;
    margin: 1rem auto 2rem auto;
    border-bottom: 1px solid ${(props) => props.theme.colors.grey};
    padding: 0rem auto;
    position: relative;
    text-align: center;
    h1 {
      font-weight: 400;
    }
  }

  @media screen and (min-width: 768px) {
    padding: 32px;
    box-shadow: 0 0 30px rgba(0, 0, 0, 0.2);
    width: 1400px;
    max-width: 100%;
    margin: 0 auto;
  }

  p {
    line-height: 1.6;
    color: ${(props) => props.theme.colors.dark};
  }
`;

const DesktopOnly = styled.div`
  width: 100%;
  @media (max-width: 1024px) {
    display: none;
  }
`;
